import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import filter from 'lodash/filter';
import classNames from 'classnames/bind';
import List from 'yoda-core-components/lib/components/List/List';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import CouponDrawer from 'yoda-core-components/lib/assets/svg/CouponDrawer.svg';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import couponAction from '../../actions/CouponAction';
import adjustmentAction from '../../actions/AdjustmentAction';
import SiteComponent from '../SiteComponent/SiteComponent';
import CouponCard from '../CouponCard/CouponCard';
import CouponAppliedModal from '../CouponAppliedModal/CouponAppliedModal';
import * as styles from './CouponListTheme.css';
import { messagesLevels } from '../Messages/Messages.config';
import Messages from '../Messages';
import User from '../../helpers/User/User';
import YodaProductCartridge from '../YodaProductCartridge/YodaProductCartridge';
import Config from '../CouponCard/CouponConfig';
import { CouponCategories } from '../../common/Constants';
import { selectApplyingToEmptyCart } from '../../selectors/ContextSelector';
import CouponUtilsHelper from './CouponUtilsHelper';

const cx = classNames.bind(styles);

const CouponListTypes = ['all', 'instore', 'online'];

/* istanbul ignore next */
export const StoreOnlyType = (coupon) => coupon.content.redeemingChannel === 'instore';

/* istanbul ignore next */
export const OnlineOnlyType = (coupon) => coupon.content.redeemingChannel === 'online';
/* istanbul ignore next */
export const all = (coupon) => coupon.content.redeemingChannel === 'all';

export const produceCouponList = (
    type,
    coupons,
    appliedAdjustments,
    bagItemCount,
    isDrawer,
    staticCard
) => {
    // console.log('Applied adjustment', appliedAdjustments);
    /* istanbul ignore next */
    coupons =
        coupons &&
        coupons.map((coupon, index) => {
            const promoLength =
                coupon.content && coupon.content.promoCode && coupon.content.promoCode.length > 0;
            const isAdjustmentApplied = appliedAdjustments && appliedAdjustments.length > 0;
            let appliedAdjustment = null;
            if (promoLength) {
                if (isAdjustmentApplied) {
                    appliedAdjustment = find(
                        appliedAdjustments,
                        (adjustment) =>
                            adjustment.value.toUpperCase() ===
                            coupon.content.promoCode.trim().toUpperCase()
                    );
                }

                /* istanbul ignore next */
                coupon.content.id = appliedAdjustment ? appliedAdjustment.id : null;
                /* istanbul ignore next */
                coupon.content.savings = appliedAdjustment
                    ? parseFloat(appliedAdjustment.amount)
                    : null;
                coupon.content.couponApplied = coupon.content.id !== null;
            } // do it if the code is valid

            /**
             * Write the logic for Adding best coupon info to response.
             */
            if (
                promoLength &&
                appliedAdjustments &&
                appliedAdjustments.bestCoupons &&
                appliedAdjustments.bestCoupons.length > 0
            ) {
                const { bestCoupons } = appliedAdjustments;
                const isBestCoupon = find(
                    bestCoupons,
                    (bestcoupon) =>
                        bestcoupon.promoCode.toUpperCase() ===
                        coupon.content.promoCode.trim().toUpperCase()
                );

                coupon.content.bestCoupon = isBestCoupon ? isBestCoupon.bestCoupon : null;
                coupon.content.totalDiscount = isBestCoupon ? isBestCoupon.totalDiscount : null;
            } else if (bagItemCount === 0) {
                coupon.content.bestCoupon = null; // adding default value
                coupon.content.totalDiscount = null; // adding default value
            }
            coupon.index = index;
            return coupon;
        });

    if (coupons && coupons.length && isDrawer) {
        coupons = [...coupons, staticCard];
        return coupons;
    }
    /**
     * applied Adjustments as attribute bestcoupon then Just Add it to coupon / coupons
     * bestCoupon: val, totalDiscount: some val, promoCode: val
     */
    switch (type) {
        case CouponListTypes[0]:
        default:
            return coupons.filter(all);
        /* istanbul ignore next */
        case CouponListTypes[1]:
            return coupons.filter(StoreOnlyType);
        /* istanbul ignore next */
        case CouponListTypes[2]:
            return coupons.filter(OnlineOnlyType);
    }
};

// TODO :: Needs Complete Code cleanup/revamp
// removing all unnecessary code and optimizing the code
export class CouponList extends SiteComponent {
    /**
     * isAdjustmentCallMade
     * Makes adjustement call only once
     * @type {bool}
     */
    static isAdjustmentCallMade = false;

    /**
     * showErrorPopups
     * show error popup only once
     * @type {bool}
     */
    static showErrorPopups = false;

    /**
     * hasUserStateChanged
     * call API only once
     * @type {bool}
     */
    static hasUserStateChanged = false;

    static defaultProps = {
        coupons: [],
        actions: {},
        automationId: '',
        deviceType: {},
        modalOnClose: null,
        from: null,
        inlineMessaging: false,
        couponDetailsModal: false,
        isCouponDrawer: false,
        couponLast: {},
    };

    static propTypes = {
        coupons: PropTypes.arrayOf(PropTypes.object).isRequired,
        actions: PropTypes.object.isRequired,
        automationId: PropTypes.string,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        modalOnClose: PropTypes.func,
        from: PropTypes.string,
        inlineMessaging: PropTypes.bool,
        couponDetailsModal: PropTypes.bool,
        isCouponDrawer: PropTypes.bool,
        couponLast: PropTypes.oneOfType([PropTypes.object]),
    };

    constructor(props) {
        super(props);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.state = {
            showAppliedModal: false,
            showAppliedPopUp: false,
            modalState: [],
            isDrawer: props.from === 'drawer' || false,
        };
        this.couponCardRendererWithArrow = this.couponCardRendererWithArrow.bind(this);
        this.drawerContainerRef = null;
        this.applyCouponStateOnLoad = true;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.from !== 'drawer' && nextProps.from === 'drawer') {
            this.setState({ isDrawer: true });
        }
        // Removing coupon state if present
        const appliedCouponData = nextProps.appliedAdjustments;
        if (
            this.applyCouponStateOnLoad &&
            !isEqual(appliedCouponData, this.props.appliedAdjustments)
        ) {
            /* istanbul ignore next */
            if (appliedCouponData.length) {
                const appliedCouponDetails = filter(
                    appliedCouponData,
                    (couponData) => couponData.id && couponData.code === 'COUPON'
                );
                if (appliedCouponDetails[0] && !Cookies.load('COUPON_STATE')) {
                    CouponUtilsHelper.savePromoCode(appliedCouponDetails[0].value);
                }
                this.applyCouponStateOnLoad = false;
            }
        }
        /**
         * No need to execute when you don't need Modal popup
         */
        if (!this.props.inlineMessaging) {
            const currentResp = get(this, 'props.couponApplicationState.response');
            const nextResp = get(nextProps, 'couponApplicationState.response');
            /* istanbul ignore else */
            if (
                !isEmpty(nextProps.couponApplicationState) &&
                !isEqual(currentResp, nextResp) &&
                nextProps.couponApplicationState &&
                nextProps.couponApplicationState.isSuccess
            ) {
                /* istanbul ignore next */
                if (
                    this.props.isAdjustmentsUpdated.category &&
                    this.props.isAdjustmentsUpdated.category === this.props.redeemingChannel &&
                    this.state.showAppliedModal !== true
                ) {
                    this.setState({ showAppliedModal: true });
                }
            }

            if (
                !isEqual(
                    get(this.props.accounts, 'userProfile.userState'),
                    get(nextProps.accounts, 'userProfile.userState')
                ) &&
                !User.isUserLoggedIn() &&
                !CouponList.hasUserStateChanged
            ) {
                this.props.actions.getAdjustments({
                    drawerLoader: true,
                }); // Call the Adjustments to remove the coupon applied and bestcoupons given
                CouponList.hasUserStateChanged = true;
            }

            if (
                !isEmpty(nextProps.couponPopupMessages) &&
                !isEqual(this.props.couponPopupMessages, nextProps.couponPopupMessages) &&
                this.state.showAppliedPopUp !== true
            ) {
                this.setState({ showAppliedPopUp: true });
            } else {
                // Avoiding Unnecessary rerendering
                if (this.state.showAppliedPopUp !== false) {
                    this.setState({ showAppliedPopUp: false });
                }

                CouponList.showErrorPopups = false;
            }
        } // end of if
    }

    componentDidMount() {
        // if drawer already preloaded adjustment calls, do nothing
        // if (this.props.preloadedAdjustmentCalls) return;

        // if applyingToEmptyCart, make the adjustment call
        // Will be using bagItemCount instead of DPOrder and OrderId
        if (
            this.props.bagItemCount &&
            this.props.bagItemCount > 0 &&
            (!CouponList.isAdjustmentCallMade || this.props.from === 'drawer')
        ) {
            this.props.actions.getAdjustments({
                drawerLoader: true,
            });
            // Dont repeat the call on APIS
            // Unless it's coupon drawer - CouponList.isAdjustmentCallMade remains true when collapsing drawer
            CouponList.isAdjustmentCallMade = true;
            /* istanbul ignore next */
        } else if (
            this.props.applyingToEmptyCart &&
            (!CouponList.isAdjustmentCallMade || this.props.from === 'drawer')
        ) {
            this.props.actions.getAppliedDiscounts();
            CouponList.isAdjustmentCallMade = true;
        } else {
            this.props.actions.getCouponsLoaded();
        }
    }

    couponCardRenderer(variant = 'Default') {
        /* istanbul ignore next */
        return (dataItem, index) => {
            const disableInteraction = this.shouldDisableInteraction(
                this.props.couponDetailsModal,
                dataItem,
                this.props.deviceType
            );
            return (
                <div className={cx('couponListContentBlock', { disableInteraction })}>
                    {this.state.isDrawer &&
                        this.props.deviceType &&
                        !this.props.deviceType.isMobile && (
                            <Icon
                                iconType="svg"
                                viewBox="0 0 48 48"
                                className={cx('couponDrawerIcon')}
                                pathClassName={cx('drawerHeaderIcon')}
                            >
                                <CouponDrawer />
                            </Icon>
                        )}
                    <CouponCard
                        couponData={dataItem}
                        deviceType={this.props.deviceType}
                        couponVariant={variant}
                        couponSlot={index + 1}
                        redeemingChannel={this.props.redeemingChannel}
                        {...this.props}
                        displayCouponType={this.state.isDrawer}
                        drawerContainerRef={this.drawerContainerRef}
                        isCouponDrawer={this.props.isCouponDrawer}
                    />
                </div>
            );
        };
    }

    callbackRef = (node) => {
        this.couponCardRef = node;
    };

    shouldDisableInteraction = (highlightCardSlot, dataItem, devicetype) => {
        let disableInteraction = false;
        if (
            highlightCardSlot &&
            highlightCardSlot - 1 !== dataItem.index &&
            !(devicetype && devicetype.isMobile)
        ) {
            disableInteraction = true;
        }
        return disableInteraction;
    };

    couponCardRendererWithArrow(dataItem, listContext, highlightCardSlot) {
        const disableInteraction = this.shouldDisableInteraction(
            highlightCardSlot,
            dataItem,
            this.props.deviceType
        );
        // maintain the list height while card moves around the screen
        /* istanbul ignore next */
        // const iconHeight = this.couponCardRef && this.couponCardRef.getBoundingClientRect().height;
        // style={{ height: `${iconHeight}px` }}
        /* istanbul ignore next */
        return (
            <div
                className={cx('couponListCardBlock', { disableInteraction })}
                ref={(cardPane) => {
                    const myPane = get(cardPane, 'parentElement', cardPane);
                    listContext.productPane = myPane;
                }}
            >
                <Icon
                    iconType="svg"
                    viewBox="0 0 48 48"
                    className={cx('couponDrawerIcon')}
                    pathClassName={cx('drawerHeaderIcon')}
                >
                    <CouponDrawer />
                </Icon>
                <CouponCard
                    callbackRef={
                        /* istanbul ignore next */
                        this.callbackRef
                    }
                    couponData={dataItem}
                    deviceType={this.props.deviceType}
                    couponVariant="Default"
                    couponSlot={dataItem.index + 1}
                    redeemingChannel={this.props.redeemingChannel}
                    {...this.props}
                    displayCouponType={this.state.isDrawer}
                    drawerContainerRef={this.drawerContainerRef}
                    isCouponDrawer={this.props.isCouponDrawer}
                />
            </div>
        );
    }

    handleCloseModal = () => {
        this.setState({ showAppliedModal: false });

        /* istanbul ignore next */
        if (this.props.modalOnClose) {
            this.props.modalOnClose();
        }
    };

    renderAppliedModal = () => {
        /* istanbul ignore next */
        const {
            coupons,
            appliedAdjustments,
            applyingToEmptyCart,
            couponApplicationState,
            deviceType,
        } = this.props;
        const { response } = couponApplicationState;
        const promoCode = response.data.value;
        const channel = 'TOF';

        const {
            title,
            savings,
            message,
            level,
            applyingToEmptyCartCTA,
        } = CouponUtilsHelper.getAppliedCouponInfo(
            response,
            coupons,
            appliedAdjustments,
            applyingToEmptyCart,
            promoCode
        );

        return (
            <CouponAppliedModal
                title={title}
                savings={savings}
                message={message}
                onClose={this.handleCloseModal}
                channel={channel}
                automationId="at-coupon-applied-update-msg"
                level={level}
                applyingToEmptyCart={this.props.applyingToEmptyCart}
                applyingToEmptyCartCTA={applyingToEmptyCartCTA}
                deviceType={deviceType}
                promoCode={promoCode}
            />
        );
    };

    renderErrorPopups() {
        let renderErrorHtml = null;
        if (CouponList.showErrorPopups === false && this.state.showAppliedPopUp) {
            CouponList.showErrorPopups = true;
            renderErrorHtml = (
                <Messages
                    id="errorPopUp"
                    automationId="at-coupon-error-popup"
                    level={messagesLevels.popup}
                    messages={this.props.couponPopupMessages}
                />
            );
        }

        return renderErrorHtml;
    }

    renderCouponList() {
        const {
            coupons,
            redeemingChannel,
            appliedAdjustments,
            bagItemCount,
            couponLast,
        } = this.props;
        const couponList = produceCouponList(
            redeemingChannel,
            coupons,
            appliedAdjustments,
            bagItemCount,
            this.state.isDrawer,
            couponLast
        ); // getting the updated coupon List.
        return (
            <div>
                {' '}
                {coupons.length > 0 && (
                    <div className={cx('couponListWrapper')}>
                        <div automationId="at-coupon-channel-name" className={cx('title')}>
                            {CouponCategories[redeemingChannel]}
                        </div>
                        <List
                            datasource={couponList}
                            spacing="None"
                            direction="Vertical"
                            itemSpacing="None"
                            childRenderer={this.couponCardRenderer()}
                            automationId="at-coupon-card-renderer"
                            listBodyClass={cx('couponListBody')}
                            listStyleClass={cx('couponListBlock')}
                            itemStyleClass={cx(
                                'listAnimation',
                                'couponListItem',
                                'xl12',
                                'lg12',
                                'md6',
                                'sm12'
                            )}
                        />
                    </div>
                )}
            </div>
        );
    }

    renderCouponListWithArrow() {
        const {
            coupons,
            redeemingChannel,
            appliedAdjustments,
            bagItemCount,
            deviceType,
            couponLast,
        } = this.props;
        // if (!this.props.coupons.length) return null;
        const couponList = produceCouponList(
            redeemingChannel,
            coupons,
            appliedAdjustments,
            bagItemCount,
            this.state.isDrawer,
            couponLast
        ); // getting the updated coupon List.
        return (
            <div className={cx('couponCarousalWrapper')}>
                <div automationId="at-coupon-channel-name" className={cx('title')}>
                    {CouponCategories[redeemingChannel]}
                </div>
                <YodaProductCartridge
                    displayPartial={false}
                    productCartridgeList={couponList}
                    slotId="COUPON_DRAWER"
                    key="couponDrawerDesktop"
                    customRenderProductCard={deviceType}
                    deviceType={deviceType}
                    cartridgeListRenderer={this.couponCardRendererWithArrow}
                    disableLazyLoad={false}
                    pageType=""
                    panelType="CouponLists"
                    panelTitle=""
                    theme={cx('couponListItem')}
                    highlightCardSlot={this.props.couponDetailsModal}
                    productCatridgeTheme={cx('couponListBlock')}
                    prodCatridgeWrapper={cx('couponListBody')}
                    listBodyClassTheme={cx('listBodyClassTheme')}
                    isDrawer={this.state.isDrawer}
                />
            </div>
        );
    }

    render() {
        const isMobileChannel = get(this.props, 'deviceType.isMobile', false);
        const isTabletChannel = get(this.props, 'deviceType.isTablet', false);
        const isDrawerMode = this.props.from === 'drawer';

        return (
            <div
                ref={(node) => {
                    this.drawerContainerRef = node;
                }}
                className={cx('couponListContainer', {
                    drawerContainer: this.state.isDrawer,
                    isMobile: isMobileChannel,
                    isTablet: isTabletChannel,
                    disableInteraction: this.props.couponDetailsModal && !isMobileChannel,
                })}
            >
                {isMobileChannel || isTabletChannel || !isDrawerMode
                    ? this.renderCouponList()
                    : this.renderCouponListWithArrow()}
                {this.state.showAppliedModal ? this.renderAppliedModal() : ''}
                {this.state.showAppliedPopUp ? this.renderErrorPopups() : ''}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    deviceType: state.context ? state.context.deviceType : {},
    appliedAdjustments: state.appliedAdjustments || [],
    isAdjustmentsUpdated: state.isAdjustmentsUpdated,
    couponApplicationState: state.couponApplicationState,
    couponPopupMessages: state.messages && state.messages[Config.COUPON_POPUP_MESSAGES_ID],
    bagItemCount: state.bagItemCount,
    couponLast:
        state.context && state.context.preferences && state.context.preferences.couponLastSlot,
    applyingToEmptyCart: selectApplyingToEmptyCart(state),
    accounts: state.accounts || {
        userProfile: {
            firstName: null,
            accountId: null,
            rewardsStatus: null,
            userState: null,
            totalCerts: null,
        },
    },
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...adjustmentAction, ...couponAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponList);
